import { ChartNoAxesColumn } from 'lucide-react';

const UnavailableChart = () => (
  <div className="flex items-center gap-2 border border-border rounded-lg px-4 py-3 w-fit text-muted-foreground text-body">
    <ChartNoAxesColumn className="size-4 shrink-0" />
    This chart is no longer available
  </div>
);

export { UnavailableChart };
